import OrganisationInvitationsView from './OrganisationInvitationsView'
export default OrganisationInvitationsView